// SelectedLocation'u local storage'dan al
export const getSelectedLocation = () => {
  try {
    const selectedLocationJSON = localStorage.getItem('selectedLocation')
    if (selectedLocationJSON) {
      const selectedLocation: ISelectedLocation = JSON.parse(selectedLocationJSON)
      return selectedLocation
    } else {
      throw new Error('Lokasyon bulunamadı')
    }
  } catch (error) {
    console.error('getSelectedLocation Hata:', error)
    return null
  }
}

// SelectedLanguage local storage'den al
export const getSelectedLanguage = () => {
  const selectedLanguageJSON = localStorage.getItem('i18nConfig')
  let selectedLanguage: ISelectedLang

  if (selectedLanguageJSON) {
    selectedLanguage = JSON.parse(selectedLanguageJSON)
    let selectedLang = selectedLanguage.selectedLang
    return {selectedLang}
  } else {
  }
}

// Multipart/form-data dönüştürücü
export const prepareFormData = (values: any) => {
  const formData = new FormData()

  for (const key in values) {
    if (values.hasOwnProperty(key)) {
      const value = values[key]

      // Eğer value varsa
      if (value !== null && value !== undefined) {
        // Array ise
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            for (const subKey in item) {
              formData.append(`${key}[${index}][${subKey}]`, item[subKey])
            }
          })
        } else {
          // Eğer değer bir boolean ise "1" veya "0" olarak ekleyin
          if (typeof value === 'boolean') {
            formData.append(key, value ? '1' : '0')
          }
          // Eğer değer bir number ise string olarak ekleyin
          else if (typeof value === 'number') {
            formData.append(key, value.toString())
          } else if (value instanceof File) {
            // Eğer değer bir File (resim) ise doğrudan FormData'ya ekleyin
            formData.append(key, value)
          }
          // Diğer durumlarda olduğu gibi doğrudan ekleyin
          else {
            formData.append(key, value)
          }
        }
      }
    }
  }

  return formData
}

export const stringToBoolean = (values: any) => {
  const modifiedValues = {...values}

  for (const key in modifiedValues) {
    const value = modifiedValues[key]

    // Eğer değer "on" ise true, "off" ise false olarak ayarla, aksi takdirde değeri olduğu gibi bırak
    modifiedValues[key] = value === 'on' ? true : value === 'off' ? false : value
  }

  return modifiedValues
}
